export default __webpack_public_path__ + "static/media/tock.580dadee.wav";